import { Component, OnDestroy, OnInit } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { AuthService } from '../../../../services/auth.service';
import { Notification } from 'src/app/models/notification';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { UserConfigFacade } from 'src/app/state/user-config/user-config.facade';

@Component({
  selector: 'app-header-notifications-button',
  templateUrl: './header-notifications-button.component.html',
  styleUrls: ['./header-notifications-button.component.scss'],
})
export class HeaderNotificationsButtonComponent implements OnInit, OnDestroy {
  private userNotificationsSubscription: Subscription;

  notifications: Notification[];
  isPendingNotifications: boolean;

  constructor(
    private readonly apiService: ApiService,
    private readonly authService: AuthService,
    private readonly userConfigFacade: UserConfigFacade,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.userNotificationsSubscription = this.userConfigFacade.pendingNotifications$.subscribe(
      (pendingNotifications) => this.isPendingNotifications = pendingNotifications);

    this.getNotifications();
  }

  ngOnDestroy(): void {
    this.userNotificationsSubscription.unsubscribe();
  }

  getNotifications() {
    this.apiService
      .getUserUnreadNotifications(this.authService.getLoggedUser().id)
      .subscribe((notifications) => (this.notifications = notifications));
  }

  handleNotification(notification: Notification) {
    this.router.navigate(['/user/notifications'], {

      state: { notification },
    });
  }
}
